namespace('compass.group');

compass.group.ListLoaderSubmissionResultsWidget = compass.defineWidget(function ListLoaderSubmissionResultsWidget(options) {
     var me = this;
     var $j = jQuery;
     var d = jQuery.dom;
     var _settings = options;

     var _drawHeader = function() {
          var header = d.div({ className: 'header'}, _settings.labels.headerText);
          var groupName = d.div({ className: 'groupName'}, _settings.labels.groupName);

          return [header, groupName];
     };

     var _drawTable = function() {
          var table = d.div({ className: 'roomsHolder'},
               d.table({ className: 'memberTable'}, 
                    d.thead(
                         d.tr(
                              d.th({ className: "roomType"}, "Room Type"),
                              d.th({ className: "checkIn"}, "Check-in"),
                              d.th({ className: "checkOut"}, "Check-out"),
                              d.th({ className: "occupantName"}, "Name"),
                              d.th({ className: "email"}, "Email"),
                              d.th({ className: "payment"}, "Payment"),
                              d.th({ className: "expDate"}, "Exp Date"),
                              d.th({ className: "cardholderName"}, "Cardholder Name"),
                              d.th({ className: "roommateName1"}, "Roommate 1"),
                              d.th({ className: "roommateEmail1"}, "Roommate 1 Email"),
                              d.th({ className: "roommateName2"}, "Roommate 2"),
                              d.th({ className: "roommateEmail2"}, "Roommate 2 Email"),
                              d.th({ className: "roommateName3"}, "Roommate 3"),
                              d.th({ className: "roommateEmail3"}, "Roommate 3 Email"),
                              d.th({ className: "frequentGuestNumber"}, "Hotel Rewards #"),
                              d.th({ className: "arrivalRequest"}, "Arrival"),
                              d.th({ className: "departureRequest"}, "Departure"),
                              d.th({ className: "bedType"}, "Bed Type"),
                              _showCommentsHeader()
                         )
                    ), _buildTable()
               )
          );

          return [_drawReservationErrors(), table];
     };

     var _drawCancelButton = function() {
          var cancelButton = d.input({ className: 'cancelSubmission secondaryButton', value: _settings.labels.cancelButtonText}) .activate(function() {
               $j('.ListLoaderDialog').remove();
          });

          return cancelButton;
     };

     var _drawButtons = function() {
          var buttonText;
          if (_getNumberOfErrors() > 0) {
               buttonText = _settings.labels.erroredSubmitButtonText;
               var uploadButton = d.button({ className: 'uploadButton button', type: 'submit'}, buttonText);
               var fileSelect = d.input({ className: 'fileSelect', name: 'file', type: 'file'}).hide();

               uploadButton.click(function() {
                    fileSelect.click();
               });

               fileSelect.change(function() {
                    _uploadList();
               });

               return [uploadButton, fileSelect, _drawCancelButton()];
          } else {
               buttonText = _settings.labels.submitButtonText;
               var submitButton = d.button({ className: 'submitRoster button'}, buttonText).activate(function() {
                    _drawListLoaderProcessingWidget();
               });

               return [submitButton, _drawCancelButton()];
          }
     };

     var _drawReservationErrors = function() {
          if (_getNumberOfErrors() > 0) {
               me.trigger('ListLoaderWidget.GA', {action: 'Errors in form'});
               return d.div({ className: "numReservationErrors"}, _getNumberOfErrors().toString() + " of " + _settings.roster.data.length.toString() + " reservations have errors. To finish, please fix and upload the Group Roster again.");
          } else {
               return d.div({ className: "completedRoster"}, _settings.roster.data.length.toString() + " reservations are ready to review. You must click Submit Updates to finish.");
          }
     };

     var _getNumberOfErrors = function() {
          var totalErrors = 0;

          _.each(_settings.roster.data, function(room) {
               var errorTokens = room.INVALID_MESSAGE_TOKENS.split(",");
               errorTokens = _.filter(errorTokens, function(error) {
                    return error !== "" && error !== "NO_NAME";
               });

               if (errorTokens.length) {
                    totalErrors++;
               }
          });
          return totalErrors;
     };

     var _buildTable = function() {
          var groupedByHotel = _.groupBy(_settings.roster.data, 'HOTEL');

          var table = [];
          _.each(groupedByHotel, function(members, hotel) {
               table.push(d.tbody(
                    d.tr({ className: "hotelName"},
                         d.th({ colspan: 19}, hotel)
                    ),
                    _memberToTableData(members)
               ));
          });
          return table;
     };

     var _errorsToTableData = function(member) {
          var errorTokens = member.INVALID_MESSAGE_TOKENS.split(",");
          errorTokens = _.filter(errorTokens, function(error) {
               return error !== "" && error !== "NO_NAME";
          });

          // CONVERT ERROR TOKENS TO ERROR MESSAGES
          _.each(errorTokens, function(error) {
               _.each(_settings.longErrorMessages, function(longMessage, token){
                    if (error === token) {
                         var index = errorTokens.indexOf(error);
                         errorTokens[index] = longMessage;
                    }
               });
          });

          var errorMessages = "";
          _.each(errorTokens, function(error) {
               errorMessages = errorMessages + error + " ";
          });

          if (errorTokens.length) {
               return d.tr({ className: "errorMessage"},
                              d.td({ colspan: 19}, errorMessages)
               );
          }
     };

     var _sharesToTableData = function(member) {
          var sharesInfo = [];
          for (i = 0; i < 3; i++) {
               if (member.shares_array[i]) {
                    sharesInfo.push(d.td(member.shares_array[i].first_name + " " + member.shares_array[i].last_name));
                    sharesInfo.push(d.td(member.shares_array[i].email));
               } else {
                    sharesInfo.push(d.td());
                    sharesInfo.push(d.td());
               }
          }

          return sharesInfo;
     };

     var _showComments = function(member) {
          if (_settings.commentsAllowed === true) {
               return d.td(member.COMMENTS_TO_THE_HOTEL);
          }
     };

     var _showCommentsHeader = function() {
          if (_settings.commentsAllowed === true) {
               return d.th({ className: "comments"}, "Comments to the Hotel");
          }
     };

     var _memberToTableData = function(members) {
          var rows = [];
          _.each(members, function(member) {
               if (_errorsToTableData(member)) {
                    var errorClassName = "reservationError";
               } else {
                    var errorClassName = "";
               }

               rows.push(d.tr({ className: errorClassName},
                    d.td(member.ROOM_TYPE),
                    d.td(member.CHECK_IN),
                    d.td(member.CHECK_OUT),
                    d.td(member.FIRST_NAME + " " + member.LAST_NAME),
                    d.td(member.EMAIL),
                    d.td(member.CC_LAST_FOUR),
                    d.td(member.EXP_DATE),
                    d.td(member.CARDHOLDER_NAME),
                    _sharesToTableData(member),
                    d.td(member.HOTEL_REWARDS_NUMBER),
                    d.td(member.ARRIVAL),
                    d.td(member.DEPARTURE),
                    d.td(member.BED_TYPE),
                    _showComments(member)
               ));
               rows.push(_errorsToTableData(member));
          });
          return rows;
     };

     var _getFile = function() {
          var file = me.find('.fileSelect').prop('files')[0];
          var formData = new FormData();
          formData.append('excelFile', file, file.name);
          return formData;
     };

     var _uploadList = function() {
          var data = {
               file: _getFile(),
               callback: _settings.listLoaderSubmissionResultsWidget
          };
          me.trigger('ListLoaderWidget.GA', {action: 'Upload on Error Page'});
          me.trigger('ListLoaderTransferWidget.UploadList', data);
     };

     var _drawListLoaderProcessingWidget = function() {
          rosterID = {
               list_id: _settings.roster.list_id
          };
          var numReservations = _settings.roster.data.length;
          _settings.listLoaderProcessingWidget(rosterID, numReservations);
     };

     var _drawWidget = function() {
          return _drawHeader().concat(_drawTable()).concat(_drawButtons());
     };

     me.render = function(widgetElem) {
          widgetElem.append(_drawWidget());
          me.trigger('Dialog.removeCloseButton');
     };
}, {
     labels: {
          headerText: 'Group Roster',
          erroredSubmitButtonText: 'Try Again',
          submitButtonText: 'Submit Updates',
          cancelButtonText: 'Cancel',
          subHeaderText: "The list below represents your entire reservation with your current edits. Any errors are outlined in red and must be resolved before submitting."
     },
     longErrorMessages: {
          INCOMPLETE_NAME: "A valid primary occupant first name and last name are required.",
          BAD_EMAIL: "A valid email address is required.",
          BAD_CCNUMBER: "A valid credit card number is required.",
          BAD_CCTYPE: "Credit card must be American Express, Diners Club, Discover, MasterCard or Visa.",
          BAD_EXPDATE: "Credit card must have valid expiration date. Date Format MM/YY.",
          EXPDATE_BEFORE_ARRIVAL: "Credit card must not expire prior to the reservation date. Date Format MM/YY.",
          NO_NAME_ON_CARD: "The name on the credit card is required.",
          SHARE_ON_SINGLE: "Single occupancy rooms cannot have roommates.",
          SHARE_INCOMPLETE_NAME: "A valid roommate first and last name are required.",
          MORE_SHARES_THAN_OCCUPANCY: "There are too many roommates for this room type.",
          BAD_ARRIVAL: "Arrival requests must be chosen from available options.",
          BAD_DEPARTURE: "Departure requests must be chosen from available options.",
          BAD_BED_TYPE: "Bed type requests must be chosen from available options.",
          BAD_BILLING_NOTES: "Billing notes are limited to 350 characters."
     },
     commentsAllowed: true,
     WUID: 'LISTLOADERSUBMISSIONRESULTSWIDGET',
     widgetName: 'ListLoaderSubmissionResultsWidget'
});